import React, { useState } from 'react';
import Icon from './Icon';
import './SystemAdmin.css';

function MlsSettings({ mls, settings = {}, onUpdate }) {
  const systemDefault = settings.signupTrialDays != null ? Number(settings.signupTrialDays) : 30;
  const hasOverride = mls && mls.signupTrialDays != null;
  const [draft, setDraft] = useState(hasOverride ? String(mls.signupTrialDays) : '');
  const [saved, setSaved] = useState(false);

  function save() {
    const val = draft.trim();
    const n = val === '' ? undefined : Math.max(0, parseInt(val, 10) || 0);
    onUpdate && onUpdate({ signupTrialDays: n });
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  function clear() {
    setDraft('');
    onUpdate && onUpdate({ signupTrialDays: undefined });
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  return (
    <div className="sa-container">
      <div className="sa-header">
        <div>
          <h2>Settings{mls ? ` — ${mls.name}` : ''}</h2>
          <p>MLS-level settings override the System defaults for this MLS only.</p>
        </div>
      </div>

      <div className="sa-panel">
        <div className="sa-panel-title"><Icon name="gift" size={16} /> Default trial (days)</div>
        <p className="sa-mls-hint">
          How many free trial days new agents get when they sign up under this MLS.
          Leave blank to inherit the System default (<strong>{systemDefault} day{systemDefault !== 1 ? 's' : ''}</strong>).
        </p>
        <div className="sa-field-row">
          <input
            type="number" min="0" step="1"
            className="sa-input sa-input-short"
            placeholder={`${systemDefault} (system default)`}
            value={draft}
            onChange={e => { setDraft(e.target.value); setSaved(false); }}
          />
          <button className="rt-save-btn" onClick={save}>Save</button>
          {hasOverride && (
            <button className="contacts-import-cancel-btn" onClick={clear} title="Remove override — inherit System">
              Clear override
            </button>
          )}
        </div>
        {saved && <div className="sa-notice">✓ Saved</div>}
        <p className="sa-mls-hint" style={{ marginTop: 8 }}>
          Current effective trial: <strong>
            {mls && mls.signupTrialDays != null
              ? `${mls.signupTrialDays} day${mls.signupTrialDays !== 1 ? 's' : ''} (MLS override)`
              : `${systemDefault} day${systemDefault !== 1 ? 's' : ''} (system default)`}
          </strong>
        </p>
      </div>
    </div>
  );
}

export default MlsSettings;
